import styled from 'styled-components'

type Props = {
	wide?: boolean
}

export const CenterContent = styled.div<Props>`
	margin: 0 auto;
	max-width: ${({ wide }) => (wide ? 1400 : 980)}px;
	padding: 22px;
	position: relative;
`
